import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'antd/es/form/Form'
import { Form, Input, Modal, Select } from 'antd'
import { SignTitle } from '@/components'
import { t } from '@/i18n'
import {
  useRetestTask,
  useGetTaskDetailUseCaseStatus,
  useGetTaskDetailUseCaseCount,
} from '@/pages/waf/task-list/utils'

export const RetestModal = props => {
  const { id, visible, onCancel, onSuccess, name } = props
  const navigate = useNavigate()
  const [form] = useForm()

  const [retestTask, retestLoading] = useRetestTask()
  const [getTaskDetailUseCaseStatus, caseStatusOption] = useGetTaskDetailUseCaseStatus()
  const [getTaskDetailUseCaseCount] = useGetTaskDetailUseCaseCount()
  const [count, setCount] = useState(0)

  const [selectedStatuses, setSelectedStatuses] = useState<string[]>([])
  const [allSelected, setAllSelected] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (visible) {
      form.setFieldValue('result_name', name)
      setLoading(false)
      getTaskDetailUseCaseStatus({ resultId: id })
        .then(res => {
          const caseStatus = res?.data?.list?.map(item => item.caseStatus)
          setSelectedStatuses(caseStatus)
          form.setFieldsValue({ case_status: caseStatus })
          getTaskDetailUseCaseCount({
            resultId: id,
            caseStatus: caseStatus, // 否则传选中的状态
          })
            .then(r => {
              setCount(r.data.count)
            })
            .catch(_ => {})
        })
        .catch(_ => {})
    }
  }, [visible])

  const handleStatusChange = (values: string[]) => {
    // 调用获取用例总数的接口
    if (values.length === 0) {
      setCount(0)
      return
    }
    setSelectedStatuses(values)
    getTaskDetailUseCaseCount({
      resultId: id,
      caseStatus: values, // 否则传选中的状态
    })
      .then(r => {
        setCount(r.data.count)
      })
      .catch(_ => {})
  }

  const handleConfirm = values => {
    // 防止重复提交
    if (loading) {
      return
    }
    setLoading(true)

    const { result_name: resultName } = values
    retestTask({ result_name: resultName, result_id: id, case_status: selectedStatuses })
      .then(() => {
        onSuccess()
      })
      .catch(_ => {})
      .finally(() => {
        setLoading(false)
      })
  }

  const optionsMap = {
    CaseStatusExecSuccess: t('执行成功'),
    CaseStatusExecFailure: t('执行失败'),
    CaseStatusInterceptionSuccess: t('拦截成功'),
    // CaseStatusInterceptionFailure: '防护失效',
    CaseStatusCancelValid: t('取消验证'),
    CaseStatusAlert: t('告警用例'),
    CaseStatusNotAlert: t('无告警用例'),
    CaseStatusNotExecute: t('未执行'),
    CaseStatusUnExec: t('未执行'),
    CaseStatusDetectSuccess: t('检测成功'),
    CaseStatusInterceptionDefenceFail: t('防护失效'),
  }

  return (
    <Modal
      width="498px"
      title={
        <SignTitle show style={{ width: '498px' }}>
          {t('任务复测')}
        </SignTitle>
      }
      centered
      onOk={form.submit}
      visible={visible}
      destroyOnClose
      onCancel={() => {
        form.resetFields()
        onCancel()
      }}
      confirmLoading={loading}
    >
      <Form
        form={form}
        layout={'vertical'}
        onFinish={handleConfirm}
        preserve={false}
        initialValues={{ result_name: name, type: 'immediate' }}
      >
        <Form.Item
          label={t('任务名称')}
          name={'result_name'}
          rules={[
            { required: true, message: t('请输入任务名称') },
            { max: 99, message: t('任务名称最多99字') },
          ]}
        >
          <Input placeholder={t('请输入')} />
        </Form.Item>
        <Form.Item
          label={t('执行类型')}
          name={'type'}
          rules={[{ required: true, message: t('请选择执行类型') }]}
        >
          <Select placeholder={t('请选择')} disabled>
            <option value="immediate">{t('立即执行')}</option>
          </Select>
        </Form.Item>
        <Form.Item
          label={t('用例筛选')}
          name={'case_status'}
          rules={[{ required: true, message: t('请选择用例') }]}
        >
          <Select
            placeholder={t('请选择')}
            mode="multiple"
            value={selectedStatuses}
            onChange={handleStatusChange}
            maxTagCount={3}
          >
            {caseStatusOption?.map((item, i) => (
              <Select.Option
                key={i}
                value={item.caseStatus}
                label={optionsMap[item.caseStatus] || item.caseStatus}
              >
                {`${optionsMap[item.caseStatus] || item.caseStatus} (${item.caseCount})`}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <div>
          {t('本次用例总数：')}
          <span style={{ color: '#64BDC0' }}>{count || 0}</span>
          {t('个')}
        </div>
      </Form>
    </Modal>
  )
}
